import { Helmet } from 'react-helmet'
import { APP } from '@/common/strings'
import { NAVIGATION_COPY } from '@/locales/en'
import { useCurrentAccount } from '@/account/useCurrentAccount'
import AccountHoldersSection from './components/AccountHoldersSection'
import { useAccountHolderItems } from './model/useAccountHolderItems'

export default function AccountHoldersView() {
    const account = useCurrentAccount()

    const accountHolders = useAccountHolderItems()
    const copy = NAVIGATION_COPY.account

    if (!account) {
        return null
    }

    return (
        <>
            <Helmet>
                <title>
                    {copy.pageTitle} | {APP.title}
                </title>
            </Helmet>

            <AccountHoldersSection accountHolders={accountHolders} />
        </>
    )
}
